import { createSlice } from '@reduxjs/toolkit'

import { reducers } from '.reducers/libraries/bulk.template'

import removeArrayDupsByKey from '.helpers/removeArrayDupsByKey'

const initialState = {
	selected: [],
	showOkButton: false,
	showCompanySelector: false,
}

const copyBulks = createSlice({
	name: 'LIB/COPY/BULK',
	initialState,
	reducers: {
		...reducers,
		addMultipleSelected(state, { payload: libArr }) {
			state.selected = removeArrayDupsByKey([...state.selected, ...libArr], {
				selector: 'id',
			}).map((copy) => ({
				...copy,
			}))
		},
	},
})

export const {
	addSelected,
	setSelected,
	removeSelected,
	addMultipleSelected,
	removeMultipleSelected,
	clearSelected,
	setShowOkButton,
	setShowCompanySelector,
	onBulkTagsUpdated,
	updateSelected
} = copyBulks.actions

export default copyBulks.reducer
